import { createSlice } from '@reduxjs/toolkit';

import { fetchPriceResultsMoreFromIfNeeded } from './priceResultsMoreFrom.actions';
import { defaultPriceResultsMoreFromSlice } from './priceResultsMoreFrom.types';

const priceResultsMoreFromSlice = createSlice({
    extraReducers: (builder) => {
        builder.addCase(fetchPriceResultsMoreFromIfNeeded.pending, (slice, { meta }) => {
            slice.itemIds = [];
            slice.loaded = false;
            slice.loading = true;
            slice.sourceItemId = meta.arg.itemId;
        });
        builder.addCase(fetchPriceResultsMoreFromIfNeeded.fulfilled, (slice, { payload }) => {
            slice.itemIds = payload;
            slice.loaded = true;
            slice.loading = false;
        });
        builder.addCase(fetchPriceResultsMoreFromIfNeeded.rejected, (slice) => {
            slice.itemIds = [];
            slice.loaded = true;
            slice.loading = false;
        });
    },
    initialState: defaultPriceResultsMoreFromSlice,
    name: 'priceResultsMoreFrom',
    reducers: {},
});

export const priceResultsMoreFromReducer = priceResultsMoreFromSlice.reducer;
